import {Injectable} from "@angular/core";
import {ProductCollectionsEnum} from "../../shared/enums/product-collections.enum";
import {DropdownOptionModel} from "../../shared/models/components/form-controls/dropdown-option.model";
import {ConfigurationService} from "../../shared/services/configuration.service";
import {CollectionSearchConfigModel} from "../models/search-config/collection-search-config.model";

@Injectable({
    providedIn: "root"
})
export class CollectionSearchConfigService extends ConfigurationService<CollectionSearchConfigModel> {
    private get DEFAULT_COLLECTION(): ProductCollectionsEnum {
        return ProductCollectionsEnum.CA;
    }

    public getDefaultCollectionValue(): ProductCollectionsEnum {
        const config = this.config;
        if (!config) {
            return this.DEFAULT_COLLECTION;
        }

        return config.defaultCollection || this.DEFAULT_COLLECTION;
    }

    public getSortingOptions(): Array<DropdownOptionModel> {
        const config = this.config;
        if(!config.sortingOptions) {
            return new Array<DropdownOptionModel>();
        }

        const options = config.sortingOptions.map(x => new DropdownOptionModel(x.title, x.value));
        return options;
    }

    public getDefaultSortingOptionValue(): string {
        let defaultValue = this.config.sortingOptions.find(x => x.isDefault);
        if(!defaultValue) {
            defaultValue = this.config.sortingOptions[0];
        }

        return defaultValue ? defaultValue .value : "";
    }

    public getSerologicalOptions(): Array<DropdownOptionModel> {
        const hlaConfig = this.config.filters.hla;

        const options = hlaConfig.serologicalOptions || new Array<DropdownOptionModel>();
        return options;
    }

    public getDnaProbeOptions(): Array<DropdownOptionModel> {
        const hlaConfig = this.config.filters.hla;

        const options = hlaConfig.dnaProbeOptions || new Array<DropdownOptionModel>();
        return options;
    }

    public getNonHlaGenesOptions(): Array<DropdownOptionModel> {
        const hlaConfig = this.config.filters.hla;

        const options = hlaConfig.nonHlaGenesOptions || new Array<DropdownOptionModel>();
        return options;
    }

}
